export default Object.freeze({
  generic   : 'generic',
  invalidId : 'invalidId',
  noBoard   : 'noBoard',
});
